import { render, staticRenderFns } from "./ProductDiscountSuppliers.vue?vue&type=template&id=7d97bdba&"
import script from "./ProductDiscountSuppliers.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports